import { useState, useEffect } from 'react';

const flatten_survey = survey_questions => {
  return survey_questions.reduce((flat_survey, survey_question) => [ ...flat_survey, ...flatten_question(survey_question) ], []);
}

// return an array of survey questions by recursing through the next_question key of a questions options
const flatten_question = survey_question => {
  let nested = [];
  if (survey_question.options) {
    nested = survey_question.options.reduce((nested, { next_question }) => {
      if (next_question) {
        return [ ...nested, ...flatten_question(next_question) ];
      }

      return nested;
    }, []);
  }

  return [ survey_question, ...nested ];
}

const useSurvey = (survey_questions, surveyCompleteCallback, initialState = {}) => {
  const [ responses, setResponses ] = useState(initialState);

  const respondToPrompt = (prompt, response) => {
    const updated_responses = {
      ...responses,
      [prompt]: response
    }
    
    // remove responses that are no longer valid because the user chose a different select option
    const flat_questions = flatten_survey(survey_questions);
    const answered_question = flat_questions.find(survey_question => survey_question.prompt === prompt);
    const { options } = answered_question;
    (options || []).forEach(({ next_question }) => {
      if (next_question) {
        delete updated_responses[next_question.prompt];
      }
    });
    setResponses(updated_responses);
  }

  const questionIsComplete = survey_question => {
    const { prompt, type, options } = survey_question;
    if (type === 'SELECT') {
      const response = responses[prompt];
      if (response) {
        const selected_option = options.find(option => option.response === response);
        return selected_option.next_question ? questionIsComplete(selected_option.next_question) : true;
      }
      return false;
    } else {
      // type === 'TEXT' || type === 'RADIO'
      return !!responses[prompt];
    }
  }

  useEffect(() => {
    const survey_is_complete = survey_questions.reduce((survey_is_complete, survey_question, i) => {
      return survey_is_complete && questionIsComplete(survey_question);
    }, true);

    surveyCompleteCallback(survey_is_complete);
  }, [ responses ]);

  return [ responses, respondToPrompt ];
}

export default useSurvey;
